import { DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI } from '../../default-cloud-graph-calendar-event-entity-ati';
import { DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI } from '../../default-cloud-graph-comment-entity-ati';
import { DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI } from '../../default-cloud-graph-conversation-entity-ati';
import { DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI } from '../../default-cloud-graph-customer-org-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI } from '../../default-cloud-graph-dashboard-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI } from '../../default-cloud-graph-data-table-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI } from '../../default-cloud-graph-deal-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI } from '../../default-cloud-graph-design-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI } from '../../default-cloud-graph-devinfo-branch-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI } from '../../default-cloud-graph-devinfo-commit-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI } from '../../default-cloud-graph-devinfo-pull-request-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI } from '../../default-cloud-graph-devinfo-repository-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../default-cloud-graph-document-entity-ati';
import { DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI } from '../../default-cloud-graph-message-entity-ati';
import { DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI } from '../../default-cloud-graph-project-entity-ati';
import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../default-cloud-graph-remote-link-entity-ati';
import { DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI } from '../../default-cloud-graph-space-entity-ati';
import { DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI } from '../../default-cloud-graph-video-entity-ati';
import { DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI } from '../../default-cloud-graph-work-item-entity-ati';
import { NounSubtypeKey, TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { ForgeUnitoServicenowProdIcon } from './icon';
import { ForgeUnitoServicenowProdSearchResultIcon } from './search-result-icon';

export const forgeUnitoServicenowConfig: ThirdPartyConfig = {
	displayName: 'ServiceNow by Unito',
	id: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
	resourceType: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
	icon: get3PLogo(ForgeUnitoServicenowProdIcon, 'ForgeUnitoServicenow', 'medium'),
	searchResultIcon: get3PLogo(
		ForgeUnitoServicenowProdSearchResultIcon,
		'ForgeUnitoServicenow',
		'large',
	),
	integrationAri: 'ari:cloud:platform::integration/RzFogW4EQLcXYmYpKkItRUhLAn3jETMq',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.WorkItem,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Project,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Video,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Design,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DESIGN_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Message,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_MESSAGE_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Conversation,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_CONVERSATION_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Comment,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Repository,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.PullRequest,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DEVINFO_PULL_REQUEST_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Commit,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Branch,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.CustomerOrg,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_CUSTOMER_ORG_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.CustomerOrg],
			},
		],
		[
			TypeFilterValueKey.Deal,
			{
				entities3P: [
					...DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
					...DEFAULT_CLOUD_GRAPH_DEAL_ENTITY_ATI,
				],
				subTypes3P: [NounSubtypeKey.Deal],
			},
		],
		[
			TypeFilterValueKey.Space,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Dashboard,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DASHBOARD_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.DataTable,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DATA_TABLE_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.WebPage,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Calendar,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_CALENDAR_EVENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	filters: ['lastUpdated'],
	requiresOauth: false,
	isEnabled: () => true,
	displayWorkspaceNameAsProductName: true,
};
